import { withIconWrapper } from '@/hocs/withIconWrapper';

import ReactComponent from './IconSend.c.svg?react';

export const IconSend = withIconWrapper(ReactComponent);
